import React, { useContext, useEffect, useRef } from 'react';
import {PopupSliderContext} from "../../App";
import {ScrollToPosition} from "../../utils/ScrollToPosition";
import {observer} from "mobx-react-lite";
import OwlCarousel from "react-owl-carousel2";
import 'react-owl-carousel2/lib/styles.css';
import { useSwipeable } from 'react-swipeable';

const PopupSlider = () => {
    const refPopup = useRef(null);
    const refSlider = useRef(null);
    const [popupSliderContext, setPopupSliderContext] = useContext(PopupSliderContext);

    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if (refSlider && refSlider.current) {
                refSlider.current.next();
            }
        },
        onSwipedRight: () => {
            if (refSlider && refSlider.current) {
                refSlider.current.prev();
            }
        },
        onSwipedDown: () => {
            setPopupSliderContext({list: [], active: ''});
            ScrollToPosition(true);
        }
    });

    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (refPopup && refPopup.current && !refPopup.current.contains(e.target)) {
                setPopupSliderContext({list: [], active: ''});
                ScrollToPosition(true);
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [refPopup, setPopupSliderContext]);

    const options = {
        items: 1,
        nav: true,
        loop: true,
        dots: !document.body.clientWidth <= 1366,
        rewind: true,
        lazyLoad: true,
        center: false,
        startPosition: popupSliderContext.active,
        navText: [],
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
    };

    const item = {
        items: popupSliderContext.list.map((item, i) => <div className='image_modal'><img key={item.orig_image} className="mfp-img owl-lazy lazyload" data-src={item.orig_image} alt='' /></div>)
    };

    return (
        <div id="js-popup" className="mfp-wrap popup popup_slider" {...handlers}>
            <div className="mfp-container popup_content" ref={refPopup}>
                <div className="mfp-content content" >
                    <OwlCarousel
                        ref={refSlider}
                        options={options}
                        touch-action="pan-y"
                        className=" owl-carousel owl-theme"
                    >{item.items}</OwlCarousel>
                </div>
                <div className="popup_nav">
                    <button
                        className="mfp-close close"
                        type="button"
                        onClick={() =>{
                            setPopupSliderContext({list: [], active: ''});
                            ScrollToPosition(true);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(PopupSlider);